import { useState } from "react";
import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";

// ---------- Reusable Advisor Card ----------
const AdvisorCard = ({ image, alt, name, role, children, wide = false }) => (
  <div
    className={`card h-100 border-0 rounded-4 shadow-sm p-4 text-center ${wide ? "" : ""}`}
    style={{
      backgroundColor: "#ffffff",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-5px)";
      e.currentTarget.style.boxShadow = "0 10px 20px rgba(0,0,0,0.2)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "0 0.125rem 0.25rem rgba(0,0,0,0.075)";
    }}
  >
    <div className="mb-4 d-flex justify-content-center">
      <img
        src={image}
        alt={alt}
        className="rounded-circle border border-3 border-success shadow-sm"
        style={{ width: "120px", height: "120px", objectFit: "cover", objectPosition: "top" }}
      />
    </div>
    <h4 className="font-weight-bold font-size-22 mb-1 text-primary">{name}</h4>
    <p className="text-success font-weight-semibold font-size-14 text-uppercase mb-3">{role}</p>
    <hr className="mx-auto" style={{ width: "40px", opacity: 0.2 }} />
    <div className="font-size-15 text-muted mb-0 text-start" style={{ lineHeight: "1.6" }}>
      {children}
    </div>
  </div>
);

const ClientAbout = () => {
  const [openAdvisor, setOpenAdvisor] = useState(null);

  const toggleAdvisor = (index) => {
    setOpenAdvisor(openAdvisor === index ? null : index);
  };

  return (
    <>
      <ClientHeader />
      <main className="overflow-hidden">

        {/* --- EDITORIAL HERO SECTION --- */}
        <section className="homepad-about py-5" style={{ backgroundColor: "#f4f7f6" }}>
          <div className="container py-lg-5">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-5 mb-lg-0 pe-lg-5">
                <h6 className="text-success font-weight-bold text-uppercase mb-3" style={{ letterSpacing: "2px" }}>
                  Our People
                </h6>
                <h1 className="font-weight-bold montserrat text-primary mb-4" style={{ fontSize: "3.5rem", lineHeight: "1.1" }}>
                  The Minds Behind <br /> <span className="text-success">The Mission.</span>
                </h1>
                <p className="font-size-18 text-muted line-hight-3 mb-4">
                  Committed to the early identification, intervention, and family support for young children with developmental needs. Our team guides our mission, strategy, and community impact to create brighter futures.
                </p>
                <div className="d-flex align-items-center mt-5">
                  <div className="bg-primary rounded-circle p-3 me-3">
                    <img src="/assets/images/logo.png" alt="Icon" height="30" width="30" />
                  </div>
                  <div>
                    <h5 className="mb-0 font-weight-bold">The Just Generation</h5>
                    <span className="text-muted font-size-14">Foundation</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <img
                  src="/assets/images/about-img.jpg"
                  alt="Team"
                  className="w-100 rounded-4 shadow-lg"
                  style={{ objectFit: "cover", height: "500px" }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* --- ADVISORY & TECHNICAL TEAM --- */}
        <section className="py-5" style={{ backgroundColor: "#083B5C" }}>
          <div className="container py-lg-5">
            <div className="row justify-content-center text-center mb-5 pb-4">
              <div className="col-lg-8">
                <h2 className="font-weight-bold montserrat text-white font-size-46 mb-3">
                  Advisory &amp; Technical Team
                </h2>
                <p className="text-white opacity-75 font-size-18 mb-0">
                  Experts in engineering, finance, military leadership, and technology guiding our strategic growth.
                </p>
              </div>
            </div>

            {/* TOP ROW: Craig & William */}
            <div className="row g-4 justify-content-center mb-4">
              <div className="col-md-12 col-lg-6">
                <AdvisorCard
                  image="/assets/images/about-us/craig-reed.png"
                  alt="Craig Reed"
                  name="Craig Reed"
                  role="Vice President, Southern Bank Commercial Lending"
                >
                  <p className="mb-0">
                    Craig Reed has extensive experience in the banking industry, with a focus on commercial lending and real estate management. Craig worked as a Vice President of Commercial Lending at Southern Bank and Trust Company from December 2016. Craig Reed attended The University of Virginia's College at Wise from 1996-1997, but did not complete a degree or have a declared field of study during that time. Craig later attended Randolph-Macon College from 1997-2000, where they earned a Bachelor of Science (BS) degree in Economics.
                  </p>
                </AdvisorCard>
              </div>

              <div className="col-md-12 col-lg-6">
                <AdvisorCard
                  image="/assets/images/about-us/dennis-woodbury.png"
                  alt="William Blanks"
                  name="William Blanks, Sr."
                  role="Commander, U.S. Navy (Retired)"
                >
                  <p className="mb-3">
                    Advisory Focus: Leadership, Strategic Planning &amp; Community Engagement
                  </p>
                  <p className="mb-3">
                    His reported experience mentoring students is relevant to JGF's family-support and educational mission.
                  </p>
                  <p className="mb-0">
                    Recommendation: Request his preferred headshot, preferably a high-resolution civilian professional portrait or an authorized military portrait. We can then format it with the same circular framing and teal branding as the JGF Leadership Team.
                  </p>
                </AdvisorCard>
              </div>
            </div>

            {/* BOTTOM ROW: Hollis, Nazim, Gregory, Jinal, Trevor */}
            <div className="row g-4 justify-content-center">
              <div className="col-md-6 col-lg-4">
                <AdvisorCard
                  image="/assets/images/about-us/hollis-ellis.png"
                  alt="Hollis D. Ellis"
                  name="Hollis D. Ellis, P.E."
                  role="Civil Engineering & Site Development"
                >
                  <p className="mb-0">
                    President CAE, Inc. - Civil engineer associated with Providence Partnership LLC, with experience in civil engineering, site development, and project management.
                  </p>
                </AdvisorCard>
              </div>

              <div className="col-md-6 col-lg-4">
                <AdvisorCard
                  image="/assets/images/about-us/nazim-ghori.png"
                  alt="Nazim Ghori"
                  name="Nazim Ghori"
                  role="JGF Technical Advisors"
                >
                  <p className="mb-3">
                    ICommune Tech Developer Software Engineering &amp; Platform Technology
                  </p>
                  <p className="mb-0">
                    Nazim Ghori is the Co-Founder and Chief Executive Officer of iCommuneTech, the technology company involved in developing JGF's digital platform. He has more than 15 years of experience in web application development and cloud technologies. He specializes in PHP/Laravel, AWS, and DevOps.
                  </p>
                </AdvisorCard>
              </div>

              <div className="col-md-6 col-lg-4">
                <AdvisorCard
                  image="/assets/images/about-us/gregory-pomeroy.png"
                  alt="Gregory Pomeroy"
                  name="Gregory Pomeroy"
                  role="Systems Automation & Integration Consultant"
                >
                  <p className="mb-0">
                    Owner of the Pomeroy Agency consulting systems and automation business. Make.com, Zapier, QuickBooks integrations, and business process automation. The agency's work expanded toward helping owner-operated businesses improve their operational systems. An external professional profile describes Gregory as the founder of Pomeroy Agency, focused on building systems that reduce owners' dependence on manual management.
                  </p>
                </AdvisorCard>
              </div>

              <div className="col-md-6 col-lg-4">
                <AdvisorCard
                  image="/assets/images/about-us/jinal-kothari.png"
                  alt="Jinal Kothari"
                  name="Jinal Kothari"
                  role="Founder / Lead Architect, Design OneSpace"
                >
                  <p className="mb-0">
                    Jinal Kothari is a passionate licensed architect with an eye for the natural beauty found in nature, science, and physics. Her deep sensitivity is reflected in her design approach. She understands that your space can have a profound impact on your mental and physical health; thus, she takes the time to create a well-balanced design. In the past 16 years working as an architect, she has acquired vast amounts of knowledge in commercial, residential, and restaurant design. She is an excellent team player. Architecture is her passion, and she loves nothing better than the "aha" moment when her clients see their vision transformed into reality.
                  </p>
                </AdvisorCard>
              </div>

              <div className="col-md-6 col-lg-4">
                <AdvisorCard
                  image="/assets/images/about-us/trevor-nelson.png"
                  alt="Trevor Nelson"
                  name="Trevor Nelson"
                  role="Manager, Strategic Financing Services, Cherry Bekaert"
                >
                  <p className="mb-0">
                    Trevor is a member of the Cherry Bekaert New Markets Tax Credit educational content, making it a particularly relevant source for JGF's capital campaign.
                  </p>
                </AdvisorCard>
              </div>
            </div>
          </div>
        </section>

        {/* --- LEADERSHIP TEAM --- */}
        {/* --- LEADERSHIP TEAM --- */}
        <section className="py-5 my-5">
          <div className="container py-lg-4">
            <div className="row justify-content-center text-center mb-5 pb-4">
              <div className="col-lg-8">
                <h2 className="font-weight-bold montserrat text-primary font-size-46 mb-3">
                  Leadership Team
                </h2>
                <div className="mx-auto bg-success" style={{ height: "3px", width: "60px" }}></div>
              </div>
            </div>

            {/* Dennis T. Woodbury */}
            <div className="row align-items-center mb-5 pb-lg-4">
              <div className="col-lg-4 mb-4 mb-lg-0">
                <div className="position-relative mx-auto" style={{ maxWidth: "320px" }}>
                  <div className="position-absolute bg-success rounded-4 w-100 h-100" style={{ top: "14px", left: "-14px", zIndex: 0, opacity: 0.1 }}></div>
                  <img
                    src="/assets/images/about-us/dennis-woodbury.png"
                    alt="Dennis T. Woodbury"
                    className="w-100 rounded-4 shadow position-relative"
                    style={{ zIndex: 1, height: "300px", objectFit: "contain", backgroundColor: "#f8f9fa" }}
                  />
                </div>
              </div>
              <div className="col-lg-8 ps-lg-5">
                <h3 className="font-weight-bold font-size-32 mb-1 text-primary">Dennis T. Woodbury</h3>
                <p className="text-success font-weight-semibold font-size-18 mb-4 text-uppercase">Founder &amp; Chairman</p>
                <p className="font-size-16 text-muted line-hight-3">
                  Dennis T. Woodbury provides the vision and strategic leadership guiding The Just Generation Foundation. Drawing on decades of entrepreneurial and organizational leadership, he is advancing JGF's mission to strengthen early identification, intervention, and inclusive educational opportunities for children with developmental needs. His leadership focuses on building sustainable programs, strategic partnerships, and community resources that empower children and families. His leadership role emphasizes accountability, collaboration, and responsible stewardship of the Foundation's mission to expand access to early childhood developmental resources and family support for all communities.
                </p>
              </div>
            </div>

            {/* Babette L. Woodbury */}
            <div className="row align-items-center mb-5 pb-lg-4 flex-lg-row-reverse">
              <div className="col-lg-4 mb-4 mb-lg-0">
                <div className="position-relative mx-auto" style={{ maxWidth: "320px" }}>
                  <div className="position-absolute bg-primary rounded-4 w-100 h-100" style={{ top: "14px", right: "-14px", zIndex: 0, opacity: 0.1 }}></div>
                  <img
                    src="/assets/images/about-us/mrs-babbette-2.png"
                    alt="Babette L. Woodbury"
                    className="w-100 rounded-4 shadow position-relative"
                    style={{ zIndex: 1, height: "300px", objectFit: "contain", backgroundColor: "#f8f9fa" }}
                  />
                </div>
              </div>

              {/* Changed to ps-lg-5 and removed text-lg-end so text is left-aligned but properly spaced */}
              <div className="col-lg-8 ps-lg-5 text-start">
                <h3 className="font-weight-bold font-size-32 mb-1 text-primary">Babette L. Woodbury</h3>
                <p className="text-success font-weight-semibold font-size-18 mb-4 text-uppercase">Vice-Chairman &amp; Director</p>
                <p className="font-size-16 text-muted line-hight-3 mb-3">
                  Babette L. Woodbury brings 20 years of experience in early childhood education and childcare operations to The Just Generation Foundation. Her firsthand experience serving children, families, and childcare providers has revealed the critical need for earlier developmental identification, timely intervention, and greater access to inclusive educational resources.
                </p>
                <p className="font-size-16 text-muted line-hight-3 mb-3">
                  Her insights have been instrumental in shaping JGF's mission to bridge these gaps through innovative AI-assisted technology, educational resources, and professional connections that better equip families, educators, and childcare providers to support children of every ability.
                </p>
                <p className="font-size-16 text-muted line-hight-3 mb-0">
                  As Vice-Chairman and Director, Babette brings operational expertise, strategic foresight, and a deep commitment to inclusive education, helping guide the Foundation's vision of stronger families, empowered providers, and thriving communities.
                </p>
              </div>
            </div>

            {/* Janice Boyd & Juliana Armstrong & Steve Robinson */}
            <div className="row g-5 mt-4">
              <div className="col-md-6 col-lg-4">
                <img
                  src="/assets/images/about-us/mrs-janice-boyd-2.png"
                  alt="Janice Boyd"
                  className="w-100 rounded-4 mb-4 mx-auto d-block"
                  style={{ height: "260px", maxWidth: "320px", objectFit: "contain", backgroundColor: "#f8f9fa" }}
                />
                <h3 className="font-weight-bold font-size-28 mb-1 text-primary">Mrs. Janice Boyd</h3>
                <p className="text-success font-weight-semibold font-size-16 mb-3 text-uppercase">Secretary &amp; Treasurer</p>
                <p className="font-size-15 text-muted mb-3">
                  Janice Boyd brings a distinguished background in business ownership, educational support, and community service to The Just Generation Foundation. As the owner of Standard Office Cleaning, established in 1993, she has demonstrated decades of entrepreneurial leadership, provided commercial cleaning and built maintenance services throughout Hampton Roads.
                </p>
                <p className="font-size-15 text-muted mb-3">
                  Her previous experience with Norfolk Public Schools' Preschool Assessment Team (NPAT), which coordinates referrals, screenings, and evaluations for young children who may require special education services, provided valuable insight into the importance of early developmental identification and timely intervention.
                </p>
                <p className="font-size-15 text-muted mb-3">
                  This combination of business leadership and educational experience inspired her commitment to JGF's mission of connecting families, educators, and childcare providers with the resources and support needed to help children of every ability thrive.
                </p>
                <p className="font-size-15 text-muted mb-0">
                  As Secretary and Treasurer, Janice contributes organizational oversight, financial accountability, and strategic insight, helping strengthen community partnerships, promote responsible stewardship, and advance the Foundation's vision of inclusive opportunities for children and families.
                </p>
              </div>

              <div className="col-md-6 col-lg-4">
                <img
                  src="/assets/images/about-us/juliana-armstrong-2.png"
                  alt="Juliana Armstrong"
                  className="w-100 rounded-4 mb-4 mx-auto d-block"
                  style={{ height: "260px", maxWidth: "320px", objectFit: "contain", backgroundColor: "#f8f9fa" }}
                />
                <h3 className="font-weight-bold font-size-28 mb-1 text-primary">Juliana Armstrong</h3>
                <p className="text-success font-weight-semibold font-size-16 mb-3 text-uppercase">
                  Director of Development &amp; Community Engagement
                </p>
                <p className="font-size-15 text-muted mb-0">
                  Juliana Armstrong leads JGF's fundraising development, donor engagement, and community partnership initiatives. Drawing on her campaign management and development experience, she works to strengthen relationships with supporters, businesses, and community organizations. Her efforts help mobilize the financial resources and strategic partnerships needed to advance JGF's programs, capital campaign, and long-term sustainability.
                </p>
              </div>

              <div className="col-md-6 col-lg-4">
                <img
                  src="/assets/images/about-us/steve-j-robinson-2.png"
                  alt="Steve J. Robinson"
                  className="w-100 rounded-4 mb-4 mx-auto d-block"
                  style={{ height: "260px", maxWidth: "320px", objectFit: "contain", backgroundColor: "#f8f9fa" }}
                />
                <h3 className="font-weight-bold font-size-28 mb-1 text-primary">Steve J. Robinson</h3>
                <p className="text-success font-weight-semibold font-size-16 mb-3 text-uppercase">CPA</p>
                <p className="font-size-15 text-muted mb-0">
                  Steve graduated from Old Dominion University in 1980 and has more than 40 years of public accounting experience. In this time, Steve has provided tax services to a wide variety of corporate, partnership and individual tax clients. This experience has given him an in-depth understanding of the tax code and its complexities, enabling him to resolve our clients' most difficult tax issues.
                </p>
              </div>
            </div>
          </div>
        </section>

      </main>
      <ClientFooter />
    </>
  );
};

export default ClientAbout;